<template>
  <div class="site-detail" ref="sdd">

    <div class="padded" style="text-align: left;">

      <el-row align="bottom">
        <el-col :span="21">
          <h1 :class="titleClass(siteData.status)">{{siteData.siteName}}<small class="text-muted" v-if="siteData.telcoSiteId">&nbsp;|&nbsp;{{siteData.telcoSiteId}}</small></h1><br />
          <span v-html="siteStatus(siteData.status)"></span><span class="text-muted">{{isCandidate(siteData.status) && siteData.candidate && siteData.candidate.name ? ' for ' + siteData.candidate.name : ''}}</span>
          <span>
            <span v-if="siteData.structure.name"><b>{{siteData.structure.name}}</b></span>
            <span v-if="siteData.structure.height">&nbsp;|&nbsp;<b>{{siteData.structure.height}}</b>m.</span>
            | {{siteData.siteId}}
          </span>

        </el-col>


        <el-col align="right" :span="3">
          <site-action  v-if="isTowerCo() && !isSold(rowData.status)" :site-data="siteData" @change="siteChanged"></site-action>
        </el-col>

      </el-row>

      <el-row class="text-muted" v-if="isTowerCo()">

        <el-col v-if="siteData.active || siteData.dismantled" :span="8"  :class="!siteData.dismantled ? 'text-success' : 'text-danger'">
            <small>{{!siteData.dismantled ? 'Active' : 'Dismantled'}} </small>
            <strong>{{formatDate(!siteData.dismantled ? siteData.active : siteData.dismantled)}}</strong>
            <span>
              (<i>{{formatFriendlyDate(!siteData.dismantled ? siteData.active : siteData.dismantled)}}</i>)
            </span>
        </el-col>

        <el-col v-if="siteData.handover" :span="(siteData.active || siteData.dismantled) ? 8 : 16" :align="(siteData.active || siteData.dismantled) ? 'center' : 'left'">
          <small>Handover </small>
          <strong>{{formatDate(siteData.handover)}}</strong>
          (<i>{{formatFriendlyDate(siteData.handover)}}</i>)
        </el-col>


        <el-col align="right" style="font-size: 8pt;" :span="!siteData.handover  && (siteData.active || siteData.dismantled) ?  16 : (siteData.handover ? 8 : 24)">
          <small>Last Update </small>
          <el-tooltip :content="formatDateTime (siteData.updated_at) + (siteData.updated_by ? ' by ' + siteData.updated_by : '')">
          <strong>{{formatFriendlyDate (siteData.updated_at)}}</strong>
         </el-tooltip>
        </el-col>

      </el-row>


    <!-- Menu Display -  - - - - - - - -  - - - - - - - - - - - - - -  -->
    <div class="sites-view">

      <el-row>
        <el-col :xs="3" :sm="3" :md="24" :lg="24">
          <el-menu :default-active="menu"
            @select="selectView"
            :mode="isDesktop ? 'horizontal' : 'vertical'"
            background-color="#F0F8FF"
            active-text-color="#409EFF">

            <el-menu-item index="info" v-if="!isCandidate(rowData.status)">
              <sites-menu-badge title="Info" prop="info" :data="stats" icon="info" />
            </el-menu-item>

            <el-menu-item index="calendar" v-if="isTowerCo() && canAccess('project|maintenance|finance|admin')">
              <sites-menu-badge title="Calendar" prop="calendar" :data="stats" icon="calendar-days" />
            </el-menu-item>

            <el-menu-item index="actions" v-if="isTowerCo() && canAccess('project|maintenance|finance|admin')">
              <sites-menu-badge title="Actions" prop="actions" :data="stats" icon="asterisk" />
            </el-menu-item>

            <el-menu-item index="requests" v-if="isTowerCo() && canAccess('project|maintenance|finance|admin')">
              <sites-menu-badge title="Requests" prop="requests" :data="stats" icon="share-alt" />
            </el-menu-item>

            <el-menu-item index="candidate" v-if="(isTelco() || isTowerCo()) && !isLandOnly(siteData.status) && !isSold(siteData.status) && canAccess('project|management|property|maintenace|finance|admin')">
              <sites-menu-badge title="Candidate" prop="candidates" :data="stats" icon="street-view" />
            </el-menu-item>

            <el-menu-item index="equip">
              <sites-menu-badge title="Equipment" prop="assets" :data="stats" icon="cogs" />
            </el-menu-item>

            <el-menu-item index="maint" v-if="!isSold(siteData.status) && canAccess('project|maintenance|management')">
              <sites-menu-badge title="Maintenance" prop="tickets" :data="stats" icon="headset" />
            </el-menu-item>

            <el-menu-item index="workflow" v-if="(isTowerCo() || isContractorCo()) && !isSold(siteData.status) && canAccess('project|maintenance|management')">
              <sites-menu-badge title="Workflows" prop="workflow" :data="stats" icon="tasks" />
            </el-menu-item>

            <el-menu-item index="struct" v-if="(isTowerCo() || isTowerSupplierCo()) || canAccess('project|maintenance|management') && !isLandOnly(siteData.status)">
              <sites-menu-badge title="Structure" :data="stats" icon="broadcast-tower" />
            </el-menu-item>

            <el-menu-item index="attach" v-if="isTowerCo() && !isLandOnly(siteData.status)">
              <sites-menu-badge title="Attachments" prop="files" :data="stats" icon="paperclip" />
            </el-menu-item>

            <el-menu-item index="sharers" v-if="isTowerCo() && canAccess('project|maintenance|finance|management') && !isLandOnly(siteData.status)">
              <sites-menu-badge title="Sharers" prop="sharers" :data="stats" icon="users" />
            </el-menu-item>

            <el-menu-item index="tenancy" v-if="(isTowerCo() || isLandlordCo()) || canAccess('property|finance|management')">
              <sites-menu-badge title="Tenancy" :data="stats" icon="store-alt" />
            </el-menu-item>

            <el-menu-item index="permits" v-if="(isTowerCo() || isAuthority()) || canAccess('project|property|finance|admin|management')">
              <sites-menu-badge title="Permits" prop="permits" :data="stats" icon="clipboard" />
            </el-menu-item>

            <el-menu-item index="ins" v-if="(isTowerCo() || isInsuranceCo()) || canAccess('property|finance|admin|management')">
              <sites-menu-badge title="Insurance" prop="insurance" :data="stats" icon="shield-alt" />
            </el-menu-item>

            <el-menu-item index="power" v-if="(isTowerCo() || isUtility()) || canAccess('admin|management')">
              <sites-menu-badge title="Power" prop="power" :data="stats" icon="plug" />
            </el-menu-item>

            <el-menu-item index="finance" v-if="isTowerCo() && !isSold(siteData.status) || canAccess('finance|management') && !isLandOnly(siteData.status)">
              <sites-menu-badge title="Finance" prop="finance" :data="stats" icon="money-bill-alt" />
            </el-menu-item>

            <el-menu-item index="backhaul" v-if="(isTowerCo() || isTelco() || isBackhaulCo()) || canAccess('finance|management|maintenance|project')">
              <sites-menu-badge title="Backhaul" prop="backhaul" :data="stats" icon="wifi" />
            </el-menu-item>

          </el-menu>
      </el-col>


      <!-- Content Display (small but perfectly formed) - - - - - - - - -  -->
      <el-col v-if="comp" :xs="21" :sm="21" :md="24" :lg="24">
        <component v-bind="defaultProps" :is="comp" @view="selectView" />
      </el-col>

    </el-row>

      <google-map v-if="!isCandidate(rowData.status)" :lat="rowData.latitude" :lng="rowData.longitude" :zoom="18" />

      <!-- Candidate Section -->
      <section v-if="isCandidate(rowData.status)">

           <el-row :gutter="12">
             <el-col :span="24">
               <site-card :site-data="rowData" :markers="markers" map-type="terrain" :map-style="mapStyle" :zoom="16" hide-site no-structure />
            </el-col>

           </el-row>

       </section>




      </div>

    </div>
  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

import GoogleMap from '@/components/atoms/GoogleMap'
import {flatPaleMapStyle} from '@/components/maps/styles/GoogleMapStyles'


import SiteInfo from '@/components/sites/SiteInfo'
import SiteCard from '@/components/sites/SiteCard'

import SiteCalendar from '@/components/sites/SiteCalendar'

import SiteActions from '@/components/sites/SiteActions'
import SiteAttachments from '@/components/sites/SiteAttachments'
import SitesMenuBadge from '@/components/sites/SitesMenuBadge'

import SiteAction from '@/components/actions/SiteAction'
import SiteCandidates from '@/components/sites/SiteCandidates'
import SiteRequests from '@/components/sites/SiteRequests'

import EquipTable from '@/components/assets/EquipTable'

import SiteMaint from '@/components/sites/SiteMaint'
import SiteWorkflow from '@/components/sites/SiteWorkflow'

import SiteStruct from '@/components/sites/projects/SiteStruct'
import SiteSharers from '@/components/sites/SiteSharers'

// Property
import SiteTenancy from '@/components/sites/SiteTenancy'

// Finance
import SiteFinance from '@/components/sites/SiteFinance'
import SiteBackhaul from '@/components/sites/SiteBackhaul'

// Admin
import SiteUtilTable from '@/components/sites/utility/SiteUtilTable'
import SiteInsurance from '@/components/sites/SiteInsurance'
import SitePermits from '@/components/sites/SitePermits'


export default {
  mixins: [SiteMixins],

  components: {
    SiteCard,
    SiteInfo,
    SiteAction,
    SiteActions,
    SiteCalendar,
    SitesMenuBadge,
    SiteAttachments,
    SiteUtilTable,
    GoogleMap,
    SiteRequests,
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    sharerId: {
      type: Number,
      default: null
    }

  },



  methods: {

    menuView () {

      if (this.isCandidate(this.rowData.status)) {
        return 'candidate'
      }

      if (this.isTowerCo() && this.isProjectView()) {
        return 'sharers'
      }

      if (this.isTowerCo() && this.isProjectView()) {
        return 'requests'
      }

      if (this.isPropertyView()) {
        return 'tenancy'
      }

      if (this.isTowerCo() && this.isFinanceView()) {
        return 'finance'
      }

      if (this.isMaintView()) {
        return 'maint'
      }

      return 'info'
    },



    selectView (index) {

      if (this.menu !== index) {
        this.menu = index
      }

      switch (index) {
        case 'info': this.comp = SiteInfo
          break
        case 'calendar': this.comp = SiteCalendar
          break
        case 'candidate': this.comp = SiteCandidates
          break
       case 'requests': this.comp = SiteRequests
          break
        case 'actions': this.comp = SiteActions
          break
        case 'attach': this.comp = SiteAttachments
          break
        case 'backhaul': this.comp = SiteBackhaul
          break
        case 'equip': this.comp = EquipTable
          break
        case 'finance': this.comp = SiteFinance
          break
        case 'ins': this.comp = SiteInsurance
          break
        case 'tenancy': this.comp = SiteTenancy
          break
        case 'maint': this.comp = SiteMaint
          break
        case 'workflow': this.comp = SiteWorkflow
          break
        case 'struct': this.comp = SiteStruct
          break
        case 'sharers': this.comp = SiteSharers
          break
        case 'permits': this.comp = SitePermits
          break
        case 'power': this.comp = SiteUtilTable
          break
      }

    },



    siteChanged (data) {
      this.siteData = data
    }


  },



  watch: {

    stats: function (changed) {
      this.stats = changed
    }


  },



  data () {

    return {
      menu: this.menuView(),

      utilLabel: this.getUtilLabel(this.rowData),

      view: this.rowData && this.rowData.status
      ? this.rowData.status.toLowerCase().replace(' site', '')
      : 'default',

      stats: this.rowData.stats,

      baseline: this.clone(this.rowData.stats),

      siteData: this.rowData,
      origData: this.clone(this.rowData),

      selectPIC: [],
      showSelector: false,

      comp: this.selectView(this.menuView()),
      markers: this.rowData.markers ? this.rowData.markers : null,

      defaultProps: {
        rowData: this.rowData,
        siteData: this.rowData,

        readOnly: this.isSold(this.rowData.status),

        ownerId: !this.isTowerCo()
            ? this.org().id
            : null,

        siteId: this.rowData ? this.rowData.id : null,
        clientSiteId: this.rowData ? this.rowData.siteId : null,

        siteName: this.rowData ? this.rowData.siteName : null,

        sharerId: this.isTelco()
            ? this.org().id
            : this.sharerId
      },  // defaultProps

      mapStyle: flatPaleMapStyle
    }

  },



  created () {

    this.defaultProps.siteId = this.rowData.id
    this.defaultProps.clientSiteId = this.rowData.siteId
    this.defaultProps.siteName = this.rowData.siteName
    this.defaultProps.siteData = this.rowData

    this.selectView(this.menu)

    if (!this.rowData.stats) {
      this.stats = {}
    }

  }

}
</script>

<style scoped>
  .el-collapse {background-color: inherit;}
  .caption-text {color: grey;}

  .site-detail {margin-left: 33px;}
</style>



// WEBPACK FOOTER //
// SiteDetails.vue?73ce5e6e